export default __webpack_public_path__ + "static/media/arrow-right.2d1e4f47.svg";